module.exports = __webpack_public_path__ + "assets/img/myLink.83c020be.jpg";